// extracted by mini-css-extract-plugin
export default {"wrapper":"Status_wrapper__xnMi0","statusName":"Status_statusName__wMk2n"};